import React from "react";
import { isEmpty } from "lodash";
import { Typography } from "@mui/material";

import { SchoolConfig } from "../../types/schoolConfigType";

interface Props {
  school?: string;
  schoolConfig?: SchoolConfig;
}

const Logo = ({ school, schoolConfig }: Props) => {
  if (!school || isEmpty(school)) {
    return <Typography variant="h5">{school || "Ether"}</Typography>;
  }

  if (isEmpty(schoolConfig) || isEmpty(schoolConfig?.logo)) {
    return <Typography variant="h5">{school}</Typography>;
  }
  return <img src={schoolConfig?.logo} alt={school} />;
};

Logo.defaultProps = {
  school: undefined,
  schoolConfig: undefined,
};

export default Logo;
